import React, { useState, useEffect, useRef } from "react";
import "./DropdownPopUp.css";
import GurdwaraDropdown from "../LocalCummunityAds/LcaDuplicate/GurdwaraDropdown";
import { useDispatch } from "react-redux";
import { FiInfo } from "react-icons/fi";
import {
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
} from "reactstrap";
import { FaCaretDown } from "react-icons/fa";
import { setSortBy } from "../../../redux/slices/LcaSlice";
import SettingsIcon from '@mui/icons-material/Settings';
const AdsDropDownPopUp = () => {
  const [isBoxVisible, setIsBoxVisible] = useState(false);
  const [by, setBy] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const dropdownRef = useRef(null);
  const dispatch = useDispatch();

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 👉 Close when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsBoxVisible(false);
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  
  if (!isMobile) return null;

  return (
    <div className="dropdown-icon-container" ref={dropdownRef}>
       <div
        className="dropdown-icon mobile-only tooltip-container responsive-btn"
        onClick={(e) => {
          e.stopPropagation();
          setIsBoxVisible(!isBoxVisible);
        }}
      >
        <span className="btn-label"> Settings </span><SettingsIcon size={18} className="btn-icon" />
       
      </div>

      {isBoxVisible && (
        <div className="dropdown-box" onClick={(e) => e.stopPropagation()}>
          <div className="dropdown-arrow-down"></div>
          <div className="dropdown-row">
            {/* Gurdwara Dropdown */}
            <div
              className="dropdown-item p-0 m-0 d-flex items-center"
              style={{ display: "flex", alignItems: "center" }}
            >
              <GurdwaraDropdown />
            </div>

            <div className="vertical-divider"></div>

            {/* Sort By Dropdown */}
            <div className="dropdown-item">
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                  <DropdownToggle
                    style={{
                      backgroundColor: "#fff",
                      color: "#000",
                      width: "140px",
                    }}
                    className="wd_filter-btn py-1"
                  >
                    {by ? by : "Sort By"} <FaCaretDown />
                  </DropdownToggle>
                  <DropdownMenu style={{ width: "140px" }}>
                    <DropdownItem
                      onClick={() => {
                        dispatch(setSortBy(""));
                        setBy("");
                        setDropdownOpen(false);
                         setIsBoxVisible(false);
                      }}
                    >
                      Sort By
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        dispatch(setSortBy("DESC"));
                        setBy("Newer to Older");
                        setDropdownOpen(false);
                          setIsBoxVisible(false);
                      }}
                    >
                      Newer to Older
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        dispatch(setSortBy("ASC"));
                        setBy("Older to Newer");
                        setDropdownOpen(false);
                        setIsBoxVisible(false); 
                      }}
                    >
                      Older to Newer
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdsDropDownPopUp;
